import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-horizontal-icon',
  templateUrl: './design-horizontal.component.html'
})
export class DesignHorizontalComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
